// Shared CMMD work-intake cache policy used by both web and server.
// 2 minutes = fresh window, 5 minutes = max stale window.
export const CMMD_WORK_INTAKE_FRESH_MS = 120_000;
export const CMMD_WORK_INTAKE_MAX_STALE_MS = 300_000;
